export default __webpack_public_path__ + "static/media/c12.f72ce01d.jpg";